export const MOBILE_WAVEFORM_BARS = [
  50, 75, 67, 100, 50, 33, 75, 50, 67, 33, 67, 50, 33,
];

/** Stable keys for waveform bars (avoid index-only keys in lists). */
export const MOBILE_WAVEFORM_BAR_KEYS = MOBILE_WAVEFORM_BARS.map(
  (_, i) => `waveform-bar-${i}`,
);
